<div class="reactions d-flex justify-content-between align-items-center">
  <tm-emoticon-reactions [reactions]="reactions"></tm-emoticon-reactions>

  <tm-comment-reactions [threads]="threads" (onToggleThreads)="toggleThreads()"></tm-comment-reactions>
</div>

<div class="card-actions" role="group">
  <div>
    @switch (reactionType) {
      @case ('react') {
        <tm-emoticon-reactions-button [value]="currentReaction" [options]="REACT_OPTIONS"  (onReaction)="react($event)"></tm-emoticon-reactions-button>
      }
      @case ('care') {
        <button type="button"
                class="btn btn-default btn-white btn-sm btn-reaction mx-2 mx-sm-4 mx-md-2 mx-lg-4"
                [ngClass]="{ 'btn-reaction-active': currentReaction?.id === 'care' }"
                (click)="care()">
        <i class="fa-solid fa-hand-holding-heart"></i> {{ 'bad-mood-streak.care' | translate }}
        </button>
      }
    }
  </div>
  @if(showDiscussButton){
  <div>
    <button type="button"
            class="btn btn-default btn-white btn-sm btn-reaction mx-2 mx-sm-4 mx-md-2 mx-lg-4"
            (click)="onDiscuss.next()">
      <i class="fa-regular fa-comment"></i> {{ discussLabel | translate }}
    </button>
  </div>
  }
</div>